<div class="container page-section-one">
    <div class="row align-items-center py-5">
        <div class="col-12">
            <app-form [inputForm]="securityCodeForm"></app-form>
        </div>
    </div>
</div>
